<template>
  <div class="py-20 bg-blackly relative">
    <div class="container">
      <div class="relative">
        <div class="lg:block absolute inset-0 hidden">
          <div v-for="(item, index) in hovers" :key="index" class="absolute inset-0">
            <CldnImg
              v-if="item.image[0]"
              :src="item.image[0].url"
              :alt="item.alt ? item.alt : item.image[0].title"
              sizes="lg:100vw"
              class="max-w-none block object-contain w-full h-full transition-opacity duration-700"
              :class="[index === currentItemIndex ? 'opacity-40 delay-200' : 'opacity-0']"
            />
          </div>
        </div>
        <div class="lg:grid absolute inset-0 hidden grid-cols-12">
          <div class="h-full col-start-8 col-end-13">
            <div v-for="(item, index) in hovers" :key="index" class="absolute bottom-0">
              <div
                v-if="item.body"
                class="text-copy fluid-base leading-relaxed font-light w-full text-white transition-opacity duration-700"
                :class="[index === currentItemIndex ? 'delay-200' : 'opacity-0']"
                v-html="item.body"
              ></div>
            </div>
          </div>
        </div>
        <div v-if="tagLine" class="text-br-green fluid-xs leading-tightest lg:mb-16 mb-4" v-html="tagLine"></div>
        <div>
          <div v-for="(item, index) in hovers" :key="index">
            <button
              class="fluid-4xl leading-none text-br-green-light lg:py-3 z-10 flex py-1 font-semibold transition-opacity duration-300"
              :class="[index === currentItemIndex ? '' : 'opacity-40 hover:opacity-70']"
              @click="currentItemIndex = index"
              v-html="item.claim"
            ></button>
            <Expandable v-if="item.body" :open="currentItemIndex === index" class="lg:hidden">
              <div class="text-copy fluid-base leading-relaxed font-light lg:-ml-4 text-white" v-html="item.body"></div>
            </Expandable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import CldnImg from '@/components/CldnImg';
import Expandable from '@/components/common/Expandable';

export default defineNuxtComponent({
  components: { CldnImg, Expandable },
  props: {
    tagLine: {
      type: String,
      default: null,
    },
    hovers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentItemIndex: 0,
    };
  },
});
</script>
